import React, { useState } from 'react'
import { supabase } from '../lib/supabase'

export default function Login() {
  const [mode, setMode] = useState('login') // 'login' | 'register'
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [nombre, setNombre] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')

  async function handleLogin(e) {
    e.preventDefault()
    setLoading(true)
    setError('')
    const { error } = await supabase.auth.signInWithPassword({ email, password })
    if (error) setError('Email o contraseña incorrectos')
    setLoading(false)
  }

  async function handleRegister(e) {
    e.preventDefault()
    setLoading(true)
    setError('')
    setSuccess('')

    const { data, error } = await supabase.auth.signUp({ email, password })
    if (error) { setError(error.message); setLoading(false); return }

    if (data.user) {
      await supabase.from('profiles').insert({
        id: data.user.id,
        email,
        nombre: nombre || email.split('@')[0],
        rol: 'alumno'
      })
      setSuccess('¡Cuenta creada! Ya puedes iniciar sesión.')
      setMode('login')
    }
    setLoading(false)
  }

  return (
    <div className="auth-page">
      <div className="auth-left">
        <img
          src="/logo.png"
          alt="Trading Woman Tenerife"
          style={{
            width: '280px',
            maxWidth: '80%',
            borderRadius: '50%',
            marginBottom: '32px',
            boxShadow: '0 0 60px rgba(201, 168, 76, 0.3)'
          }}
        />
        <div className="auth-tagline">
          Plataforma privada de<br />
          registro y análisis<br />
          de backtesting
        </div>
        <div className="auth-deco">Acceso exclusivo · Alumnas</div>
      </div>

      <div className="auth-right">
        <div className="auth-form-wrap">
          <div className="auth-title">
            {mode === 'login' ? 'Bienvenida' : 'Crear cuenta'}
          </div>
          <div className="auth-subtitle">
            {mode === 'login' ? 'Accede a tu panel' : 'Regístrate como alumna'}
          </div>

          {error && <div className="error-msg">{error}</div>}
          {success && <div className="success-msg">{success}</div>}

          <form onSubmit={mode === 'login' ? handleLogin : handleRegister}>
            {mode === 'register' && (
              <div className="form-group">
                <label className="form-label">Nombre</label>
                <input
                  className="form-input"
                  type="text"
                  placeholder="Tu nombre"
                  value={nombre}
                  onChange={e => setNombre(e.target.value)}
                />
              </div>
            )}

            <div className="form-group">
              <label className="form-label">Email</label>
              <input
                className="form-input"
                type="email"
                placeholder="tu@email.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Contraseña</label>
              <input
                className="form-input"
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                minLength={6}
              />
            </div>

            <button className="btn-primary" type="submit" disabled={loading}>
              {loading ? 'Cargando...' : mode === 'login' ? 'Entrar' : 'Crear cuenta'}
            </button>
          </form>

          <div className="auth-toggle">
            {mode === 'login' ? (
              <>¿Sin cuenta? <button onClick={() => { setMode('register'); setError('') }}>Regístrate</button></>
            ) : (
              <>¿Ya tienes cuenta? <button onClick={() => { setMode('login'); setError('') }}>Inicia sesión</button></>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
